import Layout from '../../internal/Layout.vue'
import ManufacturerPage from './index.vue'

const ManufacturerRoutes = {
  component: Layout,
  children: [
    {
      name: 'Manufacturer',
      path: '/',
      component: ManufacturerPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default ManufacturerRoutes
